import { render, staticRenderFns } from "./CommissionPurchaseIframe.vue?vue&type=template&id=0c09336a&"
import script from "./CommissionPurchaseIframe.vue?vue&type=script&lang=ts&"
export * from "./CommissionPurchaseIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports